<script setup lang="ts">
import { type Author } from "@/services/fobizzToolsApi";
import {
  type User,
  type Pupil,
  type Visitor,
} from "@/services/orval/internalApiV1";
import { Subscriber } from "@/types";

const props = defineProps<{
  users: (User | Pupil | Visitor | Subscriber | Author)[];
}>();
const emit = defineEmits(["click"]);

const MAX_AVATARS = 4;
const allAvatars = computed(() => {
  return props.users;
});

const visibleAvatars = computed(() => {
  return allAvatars.value.slice(0, MAX_AVATARS);
});

const additionalAvatarsCount = computed(() => {
  return allAvatars.value.length - MAX_AVATARS;
});
</script>
<template>
  <button
    class="avatar-list d-none d-lg-flex me-4"
    aria-label="Trigger avatar action if action is available"
    @click.prevent="emit('click')"
  >
    <Avatar
      v-for="avatar in visibleAvatars"
      :key="(avatar as User).toolsUserId"
      :user="avatar"
      :shadow="true"
      :border="true"
    />
    <Avatar
      v-if="additionalAvatarsCount > 0"
      :text="`+${additionalAvatarsCount}`"
    />
  </button>
</template>

<style lang="scss" scoped>
.avatar-list {
  display: flex;
  flex: none;
  align-items: flex-start;
  margin-right: $spacer-2;
  margin-left: auto;
  text-decoration: none;
  background-color: transparent;
  border: none;
  width: auto;
  padding: 0;

  > * {
    margin-right: -$spacer-2;
  }
}
</style>
